import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
} from "react-icons/fa";
import instagramIcon from "../assets/instagram.png";
import facebookIcon from "../assets/facebookIcon.png";
import twitterIcon from "../assets/twitter.png"; // or x.png
import youtubeIcon from "../assets/youtube.png";
import logo from "../assets/pixelwhite.png"; // Change path if needed
import linkdin from "../assets/linkdinpng.png"
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Logo */}
          <div className="footer-col footer-logo-col">
            <img src={logo} alt="Pixel Tools" className="footer-logo" />

            <p className="footer-desc">
              Delivering high quality power tools and accessories you can trust.
            </p>

            <div className="footer-social">
              <a
                href="https://www.instagram.com/pixelpowertools/"
                target="_blank"
                rel="noreferrer"
               >
                <img
                  src={instagramIcon}
                  alt="Instagram"
                  className="social-icon"
                />
              </a>

              <a
                href="https://www.facebook.com/pixelpowertools"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={facebookIcon}
                  alt="Facebook"
                  className="social-icon"
                />
              </a>

              <a
                href="https://x.com/Pixelpowertools"
                target="_blank"
                rel="noreferrer"
              >
                <img src={twitterIcon} alt="X" className="social-icon" />
              </a>

              <a
                href="https://www.youtube.com/@pixelpowertools"
                target="_blank"
                rel="noreferrer"
               >
                <img src={youtubeIcon} alt="YouTube" className="social-icon" />
              </a>

              <a
                href="https://www.linkedin.com/company/pixeltoolsofficial/?viewAsMember=true"
                target="_blank"
                rel="noreferrer"
               >
                <img src={linkdin} alt="LinkedIn" className="social-icon" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h3>QUICK LINKS</h3> 

            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/categories">Products</a>
              </li>
              <li>
                <a href="/blogs">Blogs</a>
              </li>
              <li>
                <a href="/ContactUs">Contact Us</a>
              </li>
               <li>
                <a href="/socialmedia">Follow Us</a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div className="footer-col">
            <h3>ENQUIRES</h3>

            <ul>
              <li>
                {" "}
                <a href="/T&C">Terms & Conditions</a>{" "}
              </li>{" "}
              <li>
                {" "}
                <a href="/privacypolicy">Privacy Policy</a>{" "}
              </li>{" "}
              <li>
                {" "}
                <a href="/refundpolicy">Refund Policy</a>{" "}
              </li>{" "}
              <li>
                {" "}
                <a href="/cancelltionpolicy">Cancellation Policy</a>{" "}
              </li>{" "}
              <li>
                {" "}
                <a
                  href="https://pixeltools.in/test/assets/pixel.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Catalogue
                </a>{" "}
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h3>CONTACT US</h3>

            <ul className="contact-list">
              <li>
                <FaPhoneAlt />
                +91 9100039893
              </li>

              <li>
                <FaEnvelope />
                info@pixeltools.in
              </li>

              <li>
                <FaGlobe />
                www.pixeltools.in
              </li>

              <li>
                <FaMapMarkerAlt />
                Hyderabad, Telangana, India
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} Pixel Power Tools. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
